<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">BENEFICIOS PRIVADOS (HASTA LOS ÚLTIMOS 2 AÑOS) </legend>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label class="control-label">¿Recibe alguna contribución monetaria o en especie de una persona física o moral? <b-button class="btn-popover" v-b-popover.hover.top="info.beneficios"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <!-- <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de la pareja o dependientes económicos no serán públicos. </div>
        </div> -->
        <div class="row">
          <legend>Datos de los beneficios privados</legend>
          <div class="form-group col-6">
            <label class="control-label">Señalar quien recibe los beneficios <b-button class="btn-popover" v-b-popover.hover.top="info.beneficiario"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" placeholder="Seleccione una opción" name="beneficiario" v-validate="'required'" v-model="form_item.beneficiario">
              <el-option v-for="option in beneficiarios" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('beneficiario')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Tipo de Beneficio <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_beneficio"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" placeholder="Seleccione una opción" name="tipo" v-validate="'required'" v-model="form_item.tipo_beneficio">
              <el-option v-for="option in tipos_beneficios" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_beneficio == '4'">
            <label class="control-label">Especifique </label>
            <input class="form-control" type="text" name="especifique" v-validate="'required'" v-model="form_item.especifique" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Otorgante <b-button class="btn-popover" v-b-popover.hover.top="info.otorgante"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="otorgante" class="d-inline-block" v-validate="'required'" v-model="form_item.otorgante" label="1">Persona física</p-radio>
            <p-radio name="otorgante" class="d-inline-block" v-validate="'required'" v-model="form_item.otorgante" label="2">Persona moral</p-radio>
            <small class="text-danger">{{ errors.first('otorgante')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre o razón social del otorgante <b-button class="btn-popover" v-b-popover.hover.top="info.nombre"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre" v-validate="'required'" v-model="form_item.nombre" placeholder="Nombre o razón social del otorgante ">
            <small class="text-danger">{{ errors.first('nombre')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc')}}</small>
            <small class="text-danger" v-show="validaciones.rfc"> El formato de la CURP no es válido, verifica la información </small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Forma de recepción del beneficio <b-button class="btn-popover" v-b-popover.hover.top="info.forma"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="forma" class="d-inline-block" v-validate="'required'" v-model="form_item.forma" label="1">Monetario</p-radio>
            <p-radio name="forma" class="d-inline-block" v-validate="'required'" v-model="form_item.forma" label="2">Especie</p-radio>
            <small class="text-danger">{{ errors.first('forma')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.forma == '2'">
            <label class="control-label">Especifique el beneficio <b-button class="btn-popover" v-b-popover.hover.top="info.beneficio"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="beneficio" v-validate="'required'" v-model="form_item.beneficio" placeholder="Especifique el beneficio">
            <small class="text-danger">{{ errors.first('beneficio')}}</small>
          </div>
          <div class="form-group col-6 ">
            <label class="control-label">Monto mensual aproximado del beneficio <b-button class="btn-popover" v-b-popover.hover.top="info.monto+' '+info.tipo_moneda"><i class="far fa-question-circle"></i></b-button></label>
            <div class="customCurrency">
              <b-input-group size="sm" :prepend="getSigno">
                <b-form-input name="monto" v-validate="'required|min:1'" type="number" min="0" class="text-right" v-model="form_item.monto" placeholder="0" @keyup.native="isNumber" />
                <!-- @keyup.native="isNumber($event,form_item.valor_adquisicion)" -->
                <b-dropdown right split :text="getCodigoMoneda" v-model="form_item.tipo_moneda">
                  <b-dropdown-item v-for="option in monedas" :key="option.codigo" :value="option.codigo" @click="form_item.tipo_moneda = option.id">{{option.moneda}}</b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </div>
            <small class="text-danger">{{ errors.first('monto')}}</small>
          </div>
          <!-- <div class="form-group col-6">
            <label class="control-label">Monto mensual aproximado del beneficio <b-button class="btn-popover" v-b-popover.hover.top="info.monto"><i class="far fa-question-circle"></i></b-button></label>
            <el-input-number name="monto" v-validate="'required|decimal:0'" v-model="form_item.monto" controls-position="right" :min="0"></el-input-number>
            <small class="text-danger">{{ errors.first('monto')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Tipo de moneda <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_moneda"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" name="tipo_moneda" v-validate="'required'" filterable placeholder="Seleccione una opción" v-model="form_item.tipo_moneda">
              <el-option v-for="option in monedas" class="select-default" :value="option.id" :label="option.moneda" :key="option.moneda">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo_moneda') }}</small>
          </div> -->
          <div class="form-group col-6">
            <label class="control-label">Sector productivo al que pertenece <b-button class="btn-popover" v-b-popover.hover.top="info.sector"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" name="sector" v-validate="'required'" filterable placeholder="Seleccione una opción" v-model="form_item.sector_industria_id">
              <el-option v-for="option in sectores_industria" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('sector') }}</small>
          </div>
          <div class="form-group col-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details></v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.beneficiario="{ item }">
                <div>{{filterBeneficiario(item.beneficiario)}}</div>
              </template>
              <template v-slot:item.tipo_beneficio="{ item }">
                <div>{{filterTipoBeneficio(item.tipo_beneficio)}}</div>
              </template>
              <template v-slot:item.forma="{ item }">
                <div>{{filterForma(item.forma)}}</div>
              </template>
              <template v-slot:item.otorgante="{ item }">
                <div>{{filterTipoPersona(item.otorgante)}}</div>
              </template>
              <template v-slot:item.sector_industria_id="{ item }">
                <div>{{filterSector(item.sector_industria_id)}}</div>
              </template>
              <template v-slot:item.monto="{ item }">
                <div> {{item.monto | currency}}</div>
              </template>
              <template v-slot:item.tipo_moneda="{ item }">
                <div> {{filterTipoMoneda(item.tipo_moneda)}}</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
    },
    props: ["data"],
    data() {
      return {
        validaciones: {
          rfc_parte: false
        },
        ip_id: 1,
        add_item: false,
        edit_item: null,
        pagado: null,
        bandera: '0',
        isnum: null,
        form_item: {},
        table_list: [],
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Beneficiario',
          value: 'beneficiario',
          align: 'center',
        }, {
          text: 'Tipo de Beneficio',
          value: 'tipo_beneficio',
          align: 'center',
        }, {
          text: 'Otorgante',
          value: 'otorgante',
          align: 'center',
        }, {
          text: 'Nombre o razón social',
          value: 'nombre',
          align: 'center',
        }, {
          text: 'RFC',
          value: 'rfc',
          align: 'center',
        }, {
          text: 'Forma de recepción del beneficio',
          value: 'forma',
          align: 'center',
        }, {
          text: 'Tipo de moneda',
          value: 'tipo_moneda',
          align: 'center',
        }, {
          text: 'Monto mensual aproximado',
          value: 'monto',
          align: 'center',
        }, {
          text: 'Sector',
          value: 'sector_industria_id',
          align: 'center',
        }, ],
        info: {
          beneficios: 'Es la contribución monetaria o en especie que otorga una persona física o moral con recursos privados al Declarante o alguna de las personas señaladas en el catálogo. El apoyo en especie refiere a cualquier contribución, utilizando bienes o beneficios de naturaleza diferente al dinero. Deberá reportar hasta los últimos dos años.',
          beneficiario: 'Son las personas que reciben el apoyo o beneficio privado. De las opciones del catálogo indicar quien o quienes son los beneficiarios, señalar las veces que sean necesarias.',
          tipo_beneficio: 'Seleccionar del listado el tipo de beneficio sorteo, concurso, donación u otro (especifique).',
          otorgante: 'Seleccionar si es persona física o moral.',
          nombre: 'Proporcionar el nombre o razón social completos de quien otorga el beneficio.',
          rfc: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del otorgante del beneficio.',
          forma: 'Señalar si el apoyo recibido es monetario o en especie.',
          beneficio: 'En caso de haber seleccionado en especie deberá describir en que consiste el beneficio.',
          monto: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda.',
          tipo_moneda: 'Señalar tipo de moneda en que se recibe el beneficio.',
          sector: 'Elegir el sector al que pertenece.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
      };
    },
    computed: {
      getSigno() {
        var signo = "$";
        var val = this.form_item.tipo_moneda;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        });
        return signo;
      },
      getCodigoMoneda() {
        var codigo = "MXN";
        var val = this.form_item.tipo_moneda;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            codigo = item.codigo;
          }
        });
        return codigo;
      },
    },
    watch: {},
    methods: {
      showItem() {
        this.add_item = true;
        this.$validator.resume();
        if (!this.form_item.tipo_moneda) {
          //El id Mexico es 150
          this.form_item.tipo_moneda = 97;
        }
      },

      cancelEdit() {
        //this.showItem();
        this.add_item = false;
        this.form_item = {};
        this.edit_item = null;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("beneficios_privados", this.form_item).then(response => {
                this.StepOk("Guardado");
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();
              }, error => {
                this.StepError(error);
              });
            }
          } else {
            this.StepW("Hay campos sin completar");
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = item;
        this.form_item = {
          ...this.edit_item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("beneficios_privados/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
    },
    created() {
      //this.getLocalidades(97250);
      this.ip_id = this.getKey('uid');
      this.$http.get("beneficios_privados/" + this.ip_id).then(response => {
        this.table_list = response.data.response;
        if (this.table_list) {
          if (this.table_list.length > 0) {
            this.bandera = '1';
          }
        }
      }, error => {
        this.Err(error);
      });
    },
    mounted() {
      this.checkCatalogs();
      //El id Mexico es 150
      this.form_item.pais_id = 150;
    }
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Intereses/BeneficiosPrivados.vue